import React from 'react'
 
import LoginForm from '../../../components/form/login'


/*


FormLogin.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleSeePaswordChange: PropTypes.func.isRequired
}
  */

function Login() {
  return (
      <LoginForm/>
  )
}

export default Login;